import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Hook to detect if the current viewport is mobile size
 * @returns {boolean} True if viewport is below 'sm' breakpoint (< 600px)
 */
export function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm')); // < 600px
}

